if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();
      this.form = this.querySelector('form[action$="/cart/add"]');
      this.productIdInput = this.form?.querySelector('[name=id]');
      this.addButtons = this.querySelectorAll('button[name="add"]');
      this.errorContainer = this.querySelector('.cart-item-error');

      if (this.form && this.productIdInput) {
        this.productIdInput.disabled = false;
        this.form.addEventListener('submit', this.formSubmit.bind(this));
      }
    }

    async formSubmit(evt) {
      evt.preventDefault();

      if (this.isSubmitting) return;

      if (!this.productIdInput?.value) {
        this.variantError();
        return;
      }

      this.removeErrors();
      this.isSubmitting = true;
      this.setLoading(true);

      try {
        const formData = new FormData(this.form);
        const setRadio = document.querySelector('input[name="product-set"]:checked');
        const quantity = parseInt(setRadio?.dataset.qty, 10)
          || parseInt(formData.get('quantity'), 10)
          || 1;
        const bundleQtyRatio = parseInt(setRadio?.dataset.bundleQty, 10) || 1;
        const totalJars = setRadio?.dataset.bundleVariant ? quantity + (quantity * bundleQtyRatio) : quantity;

        const purchaseRadio = document.querySelector('input[name="purchase-type"]:checked');
        const isSubscription = Boolean(purchaseRadio) && purchaseRadio.value !== 'onetime';
        const sellingPlan = isSubscription
          ? purchaseRadio.value
          : document.querySelector('[name="selling_plan"]')?.value;

        const mainId = parseInt(setRadio?.dataset.primaryVariant, 10)
          || parseInt(this.productIdInput.value, 10);
        const mainItem = { id: mainId, quantity };
        if (sellingPlan) mainItem.selling_plan = parseInt(sellingPlan, 10);

        const items = [mainItem];

        const bundleVariantId = parseInt(setRadio?.dataset.bundleVariant, 10);
        if (bundleVariantId) {
          const bundleItem = {
            id: bundleVariantId,
            quantity: quantity * bundleQtyRatio,
            properties: { _bundled_with: String(mainId) }
          };
          if (isSubscription && setRadio.dataset.bundleSellingPlan) {
            bundleItem.selling_plan = parseInt(setRadio.dataset.bundleSellingPlan, 10);
          }
          items.push(bundleItem);
        }

        if (typeof maybeAppendProtectionItem === 'function') maybeAppendProtectionItem(items);

        const grantedPerks = this.parsePerks(purchaseRadio).filter(perk => {
          if (!perk.id || (perk.requiresSubscription && !isSubscription)) return false;
          const threshold = (isSubscription && perk.subscriberMinQty) ? perk.subscriberMinQty : (perk.minQty || 1);
          return totalJars >= threshold;
        });

        const addUrl = window.routes.cart_add_url.includes('.js')
          ? window.routes.cart_add_url
          : window.routes.cart_add_url + '.js';

        const response = await fetch(addUrl, {
          ...fetchConfig(),
          body: JSON.stringify({ items })
        });
        const data = await response.json();

        if (!response.ok) {
          this.errorMessage(data);
          return;
        }

        if (grantedPerks.length) {
          const updates = {};
          const attributes = {};
          grantedPerks.forEach(perk => {
            if (perk.type === 'coupon') {
              attributes[`_${perk.id}`] = '1';
            } else {
              updates[perk.id] = 1;
            }
          });
          try {
            const perkResponse = await fetch(window.routes.cart_update_url, {
              ...fetchConfig(),
              body: JSON.stringify({ updates, attributes })
            });
            if (!perkResponse.ok) {
              console.error('Perk grant failed:', perkResponse.status, await perkResponse.text());
            }
          } catch (perkError) {
            console.error('Perk grant failed:', perkError);
          }
        }

        this.onSuccess();
      } catch (error) {
        console.error('Add to cart error:', error);
        this.errorMessage({ description: error.message || 'Unknown error' });
      } finally {
        this.isSubmitting = false;
      }
    }

    parsePerks(radio) {
      try {
        const perks = JSON.parse(radio.dataset.perks || '[]');
        return Array.isArray(perks) ? perks : [];
      } catch (error) {
        console.error('Invalid perk data:', error);
        return [];
      }
    }

    setLoading(isLoading) {
      this.addButtons?.forEach(btn => {
        btn.classList.toggle('loading', isLoading);
        if (isLoading) {
          if (!btn.disabled) {
            btn.disabled = true;
            btn.dataset.loadingDisabled = 'true';
          }
        } else if (btn.dataset.loadingDisabled) {
          btn.disabled = false;
          delete btn.dataset.loadingDisabled;
        }
      });
    }

    errorMessage(resp) {
      if (this.errorContainer) {
        const errorsField = resp.errors
          ? (typeof resp.errors === 'string' ? resp.errors : Object.values(resp.errors).flat().join(' '))
          : null;
        this.errorContainer.innerHTML = resp.description || errorsField || resp.message || 'Error adding to cart';
        this.errorContainer.style.display = 'block';
      }
      this.setLoading(false);
    }

    variantError() {
      if (this.errorContainer) {
        this.errorContainer.innerHTML = 'Please select a variant';
        this.errorContainer.style.display = 'block';
      }
    }

    removeErrors() {
      if (this.errorContainer) {
        this.errorContainer.innerHTML = '';
        this.errorContainer.style.display = 'none';
      }
    }

    async onSuccess() {
      this.setLoading(false);
      if (typeof updateCartCount === 'function') updateCartCount();

      this.openCartPopup();
      if (typeof updateCartPopup === 'function') await updateCartPopup();
    }

    openCartPopup() {
      const cartPopup = document.querySelector('#cart-popup');
      if (!cartPopup) return;
      cartPopup.classList.add('is-open');
    }
  });
}